import { boot } from 'quasar/wrappers';
import { createConfig, http, WagmiPlugin } from '@wagmi/vue';
import { bsc } from '@wagmi/vue/chains';
import { createClient, fallback } from 'viem';
import { metaMask, walletConnect } from '@wagmi/vue/connectors';

declare module '@wagmi/vue' {
  interface Register {
    config: typeof config;
  }
}

export const config = createConfig({
  chains: [bsc],
  client: ({ chain }) =>
    createClient({
      chain,
      transport: fallback([
        http('https://bsc-dataseed1.binance.org/'),
        http('https://bsc-dataseed2.binance.org/'),
        http('https://bsc-dataseed3.binance.org/'),
      ]),
    }),
  connectors: [
    metaMask({
      dappMetadata: {
        name: 'Presale | DOL',
        url: 'https://presale.dollum.com/',
        base64Icon: undefined,
      },
      enableAnalytics: true,
      extensionOnly: false,
      forceDeleteProvider: undefined,
      forceInjectProvider: undefined,
      infuraAPIKey: process.env.INFURA_API_KEY,
      injectProvider: undefined,
    }),
    walletConnect({
      showQrModal: true,
      projectId: process.env.WALLET_CONNECT_PROJECT_ID as string,
      metadata: {
        name: 'Presale | DOL',
        description: 'Presale | DOL',
        url: 'https://presale.dollum.com/',
        icons: ['https://presale.dollum.com/favicon.ico'],
      },
      qrModalOptions: {
        themeMode: 'dark',
        themeVariables: {
          '--wcm-z-index': '9999999',
        },
      },
    }),
  ],
});

export default boot(({ app }) => {
  app.use(WagmiPlugin, { config });
});
